import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getRoutePath } from "../../../utils/common";

const ErrorCard = (props) => {
  const { t } = useTranslation();
  const { title, description, anchorText, anchorLink } = props;
  return (
    <>
      <div className="notification-error">
        <div className="notification-error-card" role="alert" aria-live="polite">
          <p className="notification-error-card__title">{t(title)}</p>
          <p className="notification-error-card__text">{t(description)}</p>
        </div>
        <a href={`${getRoutePath}/${anchorLink}`}>{t(anchorText)}</a>
      </div>
    </>
  );
};

ErrorCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  anchorText: PropTypes.string.isRequired,
  anchorLink: PropTypes.string.isRequired
};

ErrorCard.defaultProps = {
  description: ""
};

export default ErrorCard;
